export default function Component() {
  return (
    <footer className="bg-gray-200 p-4 text-center">Footer Content</footer>
  );
}
